import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthContext} from "../../config/AuthContext";
import {useNavigate, useParams} from "react-router-dom";
import NavBar from "../components/NavBar";
import Login from "../root/Login";
import {Button, Card, Popconfirm, Table, Tabs, Tag} from "antd";
import Colors from "../../styles/Colors";
import {BiPencil, BiPlus, BiRefresh, BiTrash, BiUserPlus, BiIdCard, BiCheck, BiDuplicate } from "react-icons/bi";
import Historials from "../components/Historials";
import {ColumnsType, TableProps} from "antd/es/table";
import {BsEye} from "react-icons/bs";
import RebutFIltre from "../../model/multilleure/rebuts/RebutFIltre";
import {Dayjs} from 'dayjs';
import toast, {Toaster} from "react-hot-toast";
import {QuestionCircleOutlined} from "@ant-design/icons";
import { User } from '../../model/root/User';
import {GetUsuaris} from "../../dao/root/GetUsuaris";
import UsuariModal from "../admin/components/UsuariModal";
import NouUsuariModal from "../admin/components/NouUsuariModal";
import DuplicarModal from './components/DuplicarModal';
import DuplicarRolModal from './components/DuplicarRolModal';
import DuplicarHorariModal from './components/DuplicarHorariModal';
import {DeleteRol} from "../../dao/root/DeleteRol";
import {defaultRol, Rol} from "../../model/root/Rol";
import RolsList from "../menudesign/components/RolsList";
import {defaultUsuariRolEscoles, UsuariRolEscoles} from "../../model/root/UsuariRolEscoles";
import UsuarisList from "../menudesign/components/UsuarisList";
import {GetHoraris} from "../../dao/root/GetHoraris";
import {DeleteUsuari} from "../../dao/root/DeleteUsuari";
import {CiClock2} from "react-icons/ci";
import {PostUsiarisIdValidacio} from "../../dao/root/PostUsiarisIdValidacio";
import RolAdminModal from "../admin/components/RolAdminModal";
import HorariAdminModal from "../admin/components/HorariAdminModal";
import {PutHorari} from "../../dao/root/PutHorari";
import {GetEmpresas} from '../../dao/admin/GetEmpresas';

const { TabPane } = Tabs;

const GestioUsuarisAdmin = () => {
    const titol: string = "Usuaris";
    const nomPermis: string = "Admin";

    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const navigate = useNavigate();
    const {id} = useParams();
    const {empresa} = useParams();

    const [nouElementR, setNouElementR] = useState(false);
    const [elementSelectedR, setElementSelectedR] = useState<Rol>(defaultRol);
    const [coleccioR, setDadesR] = useState<Rol[]>([]);
    const [horaris, setHoraris] = useState<any[]>([]);
    const [horarisEmpresa, setHorarisEmpresa] = useState<any[]>([]);
    const [coleccio, setDades] = useState<any[]>([]);
    const [elementSelected, setElementSelected] = useState<any>({});
    const [loading, setLoading] = useState(false);
    const [nouElement, setNouElement] = useState(false);
    const [nouElementUsu, setNouElementUsu] = useState(false);
    const [duplicarElement, setDuplicarElement] = useState(false);
    const [duplicarRol, setDuplicarRol] = useState(false);
    const [duplicarHorari, setDuplicarHorari] = useState(false);
    const [editar, setEditar] = useState(false);
    const [visible, setVisible] = useState(true);
    const [nomFiltres, setNomFiltres] = useState<{ text: string; value: string }[]>([]);
    const [nomHorariFiltres, setNomHorariFiltres] = useState<{ text: string; value: string }[]>([]);
    const [nomRolFiltres, setNomRolFiltres] = useState<{ text: string; value: string }[]>([]);
    const [tipusFiltres, setTipusFiltres] = useState<{ text: string; value: string }[]>([]);
    const [coleccioUser, setDadesUser] = useState<User[]>([]);
    const [visibleRols, setVisibleRols] = useState(false);
    const [coleccioTot, setDadesTot] = useState<UsuariRolEscoles>(defaultUsuariRolEscoles);

    const permisosEdicio = user.pagines.some(pagina => pagina.descripcio === nomPermis && pagina.tipus === 1);
    const permisVisualitzacio = user.pagines.some(pagina => pagina.descripcio === nomPermis && pagina.tipus === 0);

    const [filtres, setFiltres] = useState<RebutFIltre>(new RebutFIltre());
    const [nouElementH, setNouElementH] = useState(false);
    const [elementSelectedH, setElementSelectedH] = useState<any>({id:0});
    const [visibleHoraris, setVisibleHoraris] = useState(false);

    const [empresas, setDadesEmpresa] = useState<any[]>([]);

    const typeColors: { [key: string]: string } = {
        'artiesport.ambittec.com': 'cyan',
        'mentsinquietes.ambittec.com': 'lime',
        'ambitescola.ambittec.com': 'pink',
    };

    useEffect(() => {
        if (isLoggedIn) {
            handleLoadingChange(true)
            checkDades();
        }
    }, [id]);

   async function checkDades() {
        setLoading(true);
        handleLoadingChange(true);

        // Obtener empresas
        const dadesEmpresas = await GetEmpresas(1, page); // TO-DO: Cambiar por id_parent
        setDadesEmpresa(dadesEmpresas);

        const usuarisTotals: any[] = [];
        const rolsTotals: any[] = [];
        const horarisTotals: any[] = [];

        for (const empresa of dadesEmpresas) {
            const datasource = empresa.datasource; 
            const nomEmpresa = empresa.nomEmpresa;
            try {
                const dades = await GetUsuaris(datasource);
                const horaris = await GetHoraris(datasource);

                const usuarisEmpresa = (dades.usuaris as any[]).map((user: any) => ({
                    ...user,
                    empresa: datasource
                }));

                const rolsEmpresa = (dades.rols as any[]).map((rol: any) => ({
                    ...rol,
                    empresa: datasource
                }));

                const horarisEmpresa = (horaris as any[]).map((horari: any) => ({
                    ...horari,
                    empresa: datasource
                }));

                usuarisTotals.push(...usuarisEmpresa);
                rolsTotals.push(...rolsEmpresa);
                horarisTotals.push(...horarisEmpresa);

            } catch (error) {
                console.error(`Error obteniendo datos de la empresa ${datasource}`, error);
            }
        }

        // Asignar datos combinados al estado
        setDadesUser(usuarisTotals);
        setDadesR(rolsTotals);
        setHoraris(horarisTotals);

        setNameFilters(usuarisTotals);
        setNameRolFilters(rolsTotals);
        setNameHorariFilters(horarisTotals);

        handleLoadingChange(false);
        setLoading(false);
    }

    async function checkDadesTot(empresa: string) {
        const dades1 = await GetUsuaris(empresa);
        const dadesHoraris = await GetHoraris(empresa);
        setHorarisEmpresa(dadesHoraris);

        setDadesTot(dades1);
        checkDades();
    };


    function toggleTable() {
        setVisible(!visible);
    };

    

    //DELETE

    async function deleteElement(user: User) {
        setLoading(true);
        await DeleteUsuari(user.id, user.empresa, userId);
        await checkDades();
    };
     async function deleteElementR(rol: Rol) {
        setLoading(true);
        await DeleteRol(rol.id, rol.empresa, userId);
        await checkDades();
    };
    async function deleteElementH(ele: any) {
        setLoading(true);
        await PutHorari(ele.empresa, {...ele, estat: -1}, userId);
        await checkDades();
    };

    //POST
    function togleNouElementR(element: Rol) {
        setNouElementR(!nouElement);
        setElementSelectedR(element);
        setEditar(false);
    }
     function afegirElementR(element: Rol) {
        setNouElementR(!nouElement);
        setElementSelectedR(element);
        setEditar(true);
    }
    function afegirElement() {
        setNouElementUsu(!nouElementUsu);
        setEditar(true);
    }

    function showNouUsuari(): void {
        const { origin } = window.location; // Solo el dominio y protocolo
        const newUrl = `${origin}/treballadors`;
        window.open(newUrl, '_blank'); // Abre en nueva pestaña
    }
    function toggleTableRols() {
        setVisibleRols(!visibleRols);
    }

    function togleNouElement(element: User, edit: boolean) {
        setNouElement(!nouElement);
        setEditar(edit);
        setElementSelected(element);
    }
    function togleDuplicarElement(element: User, edit: boolean) {
        setDuplicarElement(!nouElement);
        setEditar(edit);
        setElementSelected(element);
    }
    function togleDuplicarRol(element: Rol, edit: boolean) {
        setDuplicarRol(!nouElement);
        setEditar(edit);
        setElementSelected(element);
    }

    function togleDuplicarHorari(element: Rol, edit: boolean) {
        setDuplicarHorari(!nouElement);
        setEditar(edit);
        setElementSelected(element);
    }
    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };
    async function activarUsuari(id: number) {
        //toast.error("PENDENT DE PROGRAMAR");
        await PostUsiarisIdValidacio(id + "", page, toast);
        setLoading(true);
        await GetUsuaris(page);
        await checkDades();
    }

    function afegirElementH(param: any) {
        setNouElementH(!nouElement);
        setElementSelectedH(param);
        setEditar(true);
    }
    function togleNouElementH(element: any) {
        setNouElementH(!nouElement);
        setElementSelectedH(element);
        setEditar(false);
    }
    
    /**
     * close
     **/
    function handleCloseModal(value: boolean) {
        if (value){
            toast.success("GUARDAT");
            checkDades();
        }
        else
            toast.error("NO GUARDAT");
        setDuplicarRol(false);
        setNouElement(false);
        setDuplicarElement(false);
        setNouElementR(false);
        setNouElementH(false);
        setDuplicarHorari(false);
        setNouElementUsu(false);
        checkDades();
    }
    


    /**
     * FILTRES
     **/

    function setNameFilters(elements: any[]) {
        const anyNames = elements.map((element) => ({
            text: element.nom,
            value: element.nom,
        }));
        setNomFiltres(anyNames);
    }
    function setNameRolFilters(elements: any[]) {
        const anyNames = elements.map((element) => ({
            text: element.nom,
            value: element.nom,
        }));
        setNomRolFiltres(anyNames);
    }
    function setNameHorariFilters(elements: any[]) {
        const anyNames = elements.map((element) => ({
            text: element.nom,
            value: element.nom,
        }));
        setNomHorariFiltres(anyNames);
    }

    const handleNumberInput = (newIdRebut: number | null, attributeName: string) => {
        const idRebut = newIdRebut || 0;
        setFiltres((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: idRebut,
        }));
    };

    const handleStringInput = (event: React.ChangeEvent<HTMLInputElement>, attributeName: string) => {
        const value = event.target.value || "";  // Usar una cadena vacía si el valor es nulo
        setFiltres((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: value,
        }));
    };


    const handleDateInput = (value: Dayjs | null, attributeName: string, format: string) => {
        const date = value && value.format(format) || "";

        setFiltres((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: date,
        }));
    };
   
    function showEstadistiques(ele: User) {
        navigate(`/controlhorari/${ele.id}/${ele.empresa}` );
    }
    

    /**
     * --- columns ----
     **/

    const columns: ColumnsType<any> = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            width: '8%',
            responsive: ['lg'],
            sorter: (a, b) => a.id - b.id,
            sortOrder: "descend"
        },
        {
            key: 'nom',
            title: 'Usuari',
            dataIndex: 'nom',
            width: '12%',
            filterSearch: true,
            filters: nomFiltres,
            onFilter: (value, record) => (typeof value === 'string' ? record.nom.startsWith(value) : false),
        },
        {
            key: 'nombre',
            title: 'Nom',
            dataIndex: 'nombre',
            width: '12%',
            filterSearch: true,
            filters: nomFiltres,
            onFilter: (value, record) => (typeof value === 'string' ? record.nom.startsWith(value) : false),
        },

        {
            key: 'empresa',
            title: 'Empresa',
            dataIndex: 'empresa',
            width: '15%',
            render: (name: string) => (
                    <Tag color={typeColors[name]}>
                        {name}
                    </Tag>
                ),
          
        },
         {
            key: 'estat',
            title: 'Estat',
            dataIndex: 'estat',
            width: '10%',
            responsive: ['lg'],
            sorter: (a, b) => a.estat - b.estat,
            sortOrder: "descend",
            render: (estat, ele) => (
                <>
                    <Tag color={estat === 1 ? Colors.colors.color4 : Colors.colors.color1}>
                        {estat === 1 ? "Actiu" : "Pendent"}
                    </Tag>
                </>
            ),
        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 30,
            render: (estat, ele) => (
                <>
                    {/* {permisosEdicio && ( */}
                        <>
                            <Button title={"Editar"} style={{backgroundColor: Colors.colors.color6}}
                                    onClick={() => togleNouElement(ele, false)}><BiPencil/></Button>
                            {" "}
                            <Popconfirm
                                title="Eliminant"
                                description="Vols eliminar definitivament aquest element?"
                                onConfirm={() => deleteElement(ele)}
                                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                            >
                                <Button title={"Eliminar"} style={{backgroundColor: Colors.colors.color5}}><BiTrash/></Button>
                            </Popconfirm>
                            {" "}
                        {ele.estat === 1 ?

                        <Button title={"Horari i estadístiques"} style={{backgroundColor: Colors.colors.color4}}
                                onClick={() => showEstadistiques(ele)}
                                hidden={ele.nom.lastIndexOf("superusuari") !== -1}><CiClock2/></Button>
                        :

                        <Popconfirm
                            title="Activació d'usuari"
                            description="Vols activar aquest usuari? Cal primer assignar-li permisos"
                            onConfirm={() => activarUsuari(ele.id)}
                            icon={<QuestionCircleOutlined style={{color: 'red'}}/>}
                        >
                            <Button title={"Activar"} style={{backgroundColor: Colors.colors.color3}}
                                    hidden={ele.nom.lastIndexOf("superusuari") !== -1}><BiCheck/></Button>
                        </Popconfirm>
                        }
                        {" "}
                        <Button title={"Duplicar"} style={{backgroundColor: Colors.colors.color3}}
                            onClick={() => togleDuplicarElement(ele, true)}><BiUserPlus /></Button>
                        {" "}
                        </>
                    {/* )} */}
                   
                    {" "}
                    <Button title={"Perfil"} style={{backgroundColor: Colors.colors.color2}}
                            onClick={() => navigate("/profile/" + ele.id + '/'+ ele.empresa)}
                            ><BiIdCard/></Button>
                </>
            ),
        },
    ];
    const columnsR: ColumnsType<Rol> = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            width: 15,
            //responsive: ['lg'],
            sorter: (a, b) => a.id - b.id,
            sortOrder: "descend"
        },
        {
            key: 'nom',
            title: 'Nom',
            dataIndex: 'nom',
            width: 30,
            filterSearch: true,
            filters: nomRolFiltres,
            onFilter: (value, record) => (typeof value === 'string' ? record.nom.startsWith(value) : false),
        },
        {
            key: 'empresa',
            title: 'Empresa',
            dataIndex: 'empresa',
            width: 30,
            render: (name: string) => (
                    <Tag color={typeColors[name]}>
                        {name}
                    </Tag>
            ),
          
        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 30,
            render: (estat, ele) => (
                <>
                    <Button title={"Editar"} style={{backgroundColor: Colors.colors.color6}}
                            onClick={() => togleNouElementR(ele)}
                           ><BiPencil/></Button>
                    {" "}
                    <Popconfirm
                        title="Eliminant"
                        description="Vols eliminar definitivament aquest element?"
                        onConfirm={() => deleteElementR(ele)}
                        icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                    >
                        <Button title={"Eliminar"} style={{backgroundColor: Colors.colors.color5}}><BiTrash/></Button>
                    </Popconfirm>     
                     {" "}
                    <Button title={"Duplicar"} style={{backgroundColor: Colors.colors.color3}}
                            onClick={() => togleDuplicarRol(ele, true)}><BiDuplicate  /></Button>
                    {" "}
                </>
            ),
        },
    ];

        const columnsH: ColumnsType<any> = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            width: 15,
            responsive: ['lg'],
            sorter: (a, b) => a.id - b.id,
            sortOrder: "descend"
        },
        {
            key: 'nom',
            title: 'Nom',
            dataIndex: 'nom',
            width: 30,
            filterSearch: true,
            filters: nomHorariFiltres,
            onFilter: (value, record) => (typeof value === 'string' ? record.nom.startsWith(value) : false),
        },
        {
            key: 'entrada',
            title: 'Entrada',
            dataIndex: 'entrada',
            width: 30,
             render: (name: string) => (
                    <Tag color={Colors.colors.color3}>
                        {name}
                    </Tag>
            ),
        },
        {
            key: 'sortida',
            title: 'Sortida',
            dataIndex: 'sortida',
            width: 30,
             render: (name: string) => (
                    <Tag color={Colors.colors.color3}>
                        {name}
                    </Tag>
            ),
        },
        {
            key: 'empresa',
            title: 'Empresa',
            dataIndex: 'empresa',
            width: 30,
            render: (name: string) => (
                    <Tag color={typeColors[name]}>
                        {name}
                    </Tag>
            ),
        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 30,
            render: (estat, ele) => (
                <>
                    <Button title={"Editar"} style={{backgroundColor: Colors.colors.color6}}
                            onClick={() => togleNouElementH(ele)}
                            ><BiPencil/></Button>
                    {" "}
                    <Popconfirm
                        title="Eliminant"
                        description="Vols eliminar definitivament aquest element?"
                        onConfirm={() => deleteElementH(ele)}
                        icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                    >
                            <Button title={"Eliminar"} style={{backgroundColor: Colors.colors.color5}}><BiTrash/></Button>
                    </Popconfirm>  

                    {" "}      
                    <Button title={"Duplicar"} style={{backgroundColor: Colors.colors.color3}}
                            onClick={() => togleDuplicarHorari(ele, true)}><BiDuplicate  /></Button>
                    {" "}
                </>
            ),
        },
    ];


    const onChangeH: TableProps<any>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            console.log('params', pagination, filters, sorter, extra);
    };

    const tableProps: TableProps<any> = {
        loading
    };
   


    /**
     * expander
     **/
    const expandedRowRenderR2 = (ele: Rol) => {
        return (
            <RolsList element={ele} elements={coleccioTot} checkDades={() => checkDadesTot(ele.empresa)} page={ele.empresa}/>
        );
    };
    const expandedRowRender2 = (ele: User) => {
        return (
            <UsuarisList element={ele} elements={coleccioTot} hoaris={horarisEmpresa} checkDades={() => checkDadesTot(ele.empresa)}  page={ele.empresa}/>
        );
    };


    const onChange: TableProps<any>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            console.log('params', pagination, filters, sorter, extra);
    };

    const tablePropsR: TableProps<Rol> = {
        loading
    };
     const onChangeR: TableProps<Rol>['onChange'] =
        (pagination,
        filters,
        sorter,
        extra) => {
                console.log('params', pagination, filters, sorter, extra);
    };

    
   
    
   

    if (isLoggedIn) {
        return (
            <div>
                <Toaster/>
                <NavBar/>
                <div className={"general"}>
                    <Card bordered={true} className={"elemento"}>
                        <div className={"actionButtons"}>
                            {/* {permisosEdicio && */}
                                <Button title={"Crear"} style={{backgroundColor: Colors.colors.color2}} onClick={() =>
                                    afegirElement()}><BiPlus/></Button>
                            {/* } */}
                            <Button title={"Refrescar"} style={{backgroundColor: Colors.colors.color4}} onClick={() =>
                                checkDades()}><BiRefresh/></Button>
                        </div>
                        <h4 className={"titol"} onClick={toggleTable}>{titol}</h4>
                       
                        {visible && (
                            <Tabs defaultActiveKey="tots" type="card">
                                {/* Tab para mostrar todos */}
                                <TabPane tab="Tots" key="tots">
                                    <Table
                                        {...tableProps}
                                        onChange={onChange}
                                        rowKey={(record) => `${record.empresa}-${record.id}`}
                                        columns={columns}
                                        expandable={{
                                            expandedRowRender: expandedRowRender2,
                                            onExpand: async (expanded, record: User) => {
                                                if (expanded) {
                                                    await checkDadesTot(record.empresa);
                                                }
                                            },
                                        }}
                                        dataSource={coleccioUser}
                                    />
                                </TabPane>

                                {/* Tabs dinámicos por empresa */}
                                {empresas.map((empresa: any) => (
                                    <TabPane tab={empresa.nomEmpresa} key={empresa.datasource}>
                                        <Table
                                            {...tableProps}
                                            onChange={onChange}
                                            rowKey={(record) => `${record.empresa}-${record.id}`}
                                            columns={columns}
                                            expandable={{
                                            expandedRowRender: expandedRowRender2,
                                            onExpand: async (expanded, record: User) => {
                                                if (expanded) {
                                                    await checkDadesTot(record.empresa);
                                                }
                                            },
                                        }}
                                            dataSource={coleccioUser.filter(user => user.empresa === empresa.datasource)}
                                        />
                                    </TabPane>
                                ))}
                            </Tabs>
                        )}
                    </Card>
                    <br/>
                    <Card bordered={true} className={"elemento"}>
                        <div className={"actionButtons"}>
                            <Button title={"Crear"} style={{backgroundColor: Colors.colors.color2}} onClick={() =>
                                afegirElementR(defaultRol)}><BiPlus/></Button>
                            <Button title={"Refrescar"} style={{backgroundColor: Colors.colors.color4}} onClick={() =>
                                checkDades()}><BiRefresh/></Button>
                        </div>
                        <h4 className={"titol"} onClick={toggleTableRols}>Rols</h4>
                        {visibleRols && (
                            <Tabs defaultActiveKey="tots" type="card">
                                {/* Tab para mostrar todos */}
                                <TabPane tab="Tots" key="tots">
                                    <Table
                                        loading={loading}
                                        rowKey={(record) => `${record.empresa}-${record.id}`}
                                        onChange={onChangeR}
                                        columns={columnsR}
                                        expandable={{
                                            expandedRowRender: (record) => expandedRowRenderR2(record),
                                            rowExpandable: (record) => true,
                                            onExpand: (expanded, record) => {
                                                if (expanded) {
                                                    checkDadesTot(record.empresa); 
                                                }
                                            }
                                        }}
                                        pagination={{ pageSize: 10 }}
                                        dataSource={coleccioR}
                                    />
                                </TabPane>
                                {/* Tabs dinámicos por empresa */}
                                {empresas.map((empresa: any) => (
                                    <TabPane tab={empresa.nomEmpresa} key={empresa.datasource}>
                                        <Table
                                            loading={loading}
                                            rowKey={(record) => `${record.empresa}-${record.id}`}
                                            onChange={onChangeR}
                                            columns={columnsR}
                                            expandable={{
                                                expandedRowRender: (record) => expandedRowRenderR2(record),
                                                rowExpandable: (record) => true,
                                                onExpand: (expanded, record) => {
                                                    if (expanded) {
                                                        checkDadesTot(record.empresa); 
                                                    }
                                                }
                                            }}
                                            pagination={{ pageSize: 10 }}
                                            dataSource={coleccioR.filter(rol => rol.empresa === empresa.datasource)}
                                        />
                                    </TabPane>

                                 ))}
                            </Tabs>
                        )}
                    </Card>
                    <br/>
                    <Card bordered={true} className={"elemento"}>
                        <div className={"actionButtons"}>
                            <Button title={"Crear"} style={{backgroundColor: Colors.colors.color2}} onClick={() =>
                                afegirElementH({id:0})}><BiPlus/></Button>
                            <Button title={"refrescar"} style={{backgroundColor: Colors.colors.color4}} onClick={() =>
                                checkDades()}><BiRefresh/></Button>
                        </div>
                        <h4 className={"titol"} onClick={() => setVisibleHoraris(!visibleHoraris)}>Horaris</h4>
                        {visibleHoraris && (
                            <Tabs defaultActiveKey="tots" type="card">
                                {/* Tab para mostrar todos */}
                                <TabPane tab="Tots" key="tots">
                                    <Table
                                        rowKey={(record) => `${record.empresa}-${record.id}`}
                                        onChange={onChangeH}
                                        columns={columnsH}
                                        dataSource={horaris}
                                    />
                                </TabPane>
                                {empresas.map((empresa: any) => (
                                <TabPane tab={empresa.nomEmpresa} key={empresa.datasource}>
                                    <Table
                                    
                                        onChange={onChangeH}
                                        columns={columnsH}
                                        dataSource={horaris.filter(horari => horari.empresa === empresa.datasource)}
                                    />
                                </TabPane>
                                  ))}
                            </Tabs>
                        )}
                    </Card>
                    <br/>
                    <Historials pantalla={titol} pagina={page}/>
                    {nouElement && (
                        <UsuariModal element={elementSelected} onClose={handleCloseModal} visible={nouElement} editar={editar}/>

                    )}
                    {nouElementUsu && (
                        <NouUsuariModal onClose={handleCloseModal} visible={nouElementUsu} editar={editar}/>
                    )}
                    {duplicarElement && (
                        <DuplicarModal element={elementSelected} onClose={handleCloseModal} visible={duplicarElement}/>

                    )}
                    {duplicarRol && (
                        <DuplicarRolModal element={elementSelected} onClose={handleCloseModal} visible={duplicarRol}/>

                    )}
                    {nouElementR && (
                        <RolAdminModal element={elementSelectedR} onClose={handleCloseModal} visible={nouElementR}
                                  id_usu_log={userId} editar={editar}/>
                    )}
                    {nouElementH && (
                        <HorariAdminModal element={elementSelectedH} onClose={handleCloseModal} visible={nouElementH}
                                     id_usu_log={userId} editar={editar}/>
                    )}
                    {duplicarHorari && (
                        <DuplicarHorariModal element={elementSelected} onClose={handleCloseModal} visible={duplicarHorari}/>

                    )}
                    
                </div>
            </div>
        );
    } else {
        return (
            <Login/>
        );
    }
};
export default GestioUsuarisAdmin;
